export default __webpack_public_path__ + "KaTeX_Size4-Regular.f668d5666b59392e88c787e700b5728f.woff";